import $ from 'jquery';

export default function scrollToDiv() {
  $(document).on('click', 'a[href^="#"]', function(e) {
    let id = $(this).attr('href');

    let $id = $(id);
    if ($id.length === 0) {
      return;
    }

    e.preventDefault();
    let pos = $id.offset().top - 80;
    $('body, html').animate({scrollTop: pos}, 1500);
  });
}
